import { ChainGroupID } from 'modules/endpoints/types';

export const evmGroups: ChainGroupID[] = [
  ChainGroupID.ETH_MAINNET,
  ChainGroupID.GOERLI,
  ChainGroupID.HORIZEN,
  ChainGroupID.JSON_RPC,
  ChainGroupID.KOVAN,
  ChainGroupID.NERVOS_EVM,
  ChainGroupID.RINKEBY,
  ChainGroupID.ROPSTEN,
  ChainGroupID.SEPOLIA,
  ChainGroupID.HOLESKY,
  ChainGroupID.HOODI,
  ChainGroupID.TENET,
  ChainGroupID.SCROLL_ALPHA,
  ChainGroupID.STANDARD_EVM,
  ChainGroupID.KAVA_EVM,
  ChainGroupID.AMOY,
  ChainGroupID.MUMBAI,
  ChainGroupID.CARDONA,
  ChainGroupID.POLYGON_TESTNET,
  ChainGroupID.MAIZENET,
  ChainGroupID.EVM_JSON_RPC,
  ChainGroupID.BAKLAVA,
  ChainGroupID.VFLOW,
  ChainGroupID.VFLOW_PARACHAIN,
  ChainGroupID.ETHERLINK_TESTNET,
  ChainGroupID.SHADOWNET,
];
